export default "__VITE_ASSET__D1qnS_NG__"